import { Bone, SHIMMER_STYLE } from "@ui/Molecules/Skeleton/Bone";

export function PlaceMapSkeleton() {
	return (
		<>
			<style>{SHIMMER_STYLE}</style>
			<Bone
				style={{ width: "100%", display: "block" }}
				height={480}
				radius="var(--radius-lg, 14px)"
			/>
		</>
	);
}
